import { Color, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import { useBalanceLabels } from '@features/balanceLedger'

import { EmptyResult } from '../../../../assets/images'
import * as Styled from './styles'

interface SuppliersBalanceEmptyStateProps {
  text?: string
}

export const SuppliersBalanceEmptyState = ({ text }: SuppliersBalanceEmptyStateProps): ReactElement => {
  const { bt } = useBalanceLabels()

  return (
    <Styled.Wrapper>
      <Styled.Illustration>
        <EmptyResult />
      </Styled.Illustration>
      <Text color={Color.Grey800} alignment="center">
        {text ?? bt('empty_state.no_accounts')}
      </Text>
    </Styled.Wrapper>
  )
}
